<template>
  <div>
    <header-search @searchNewWord="searchNewWord"></header-search>
    <div class="back_prev" @click="backPrev" ref="back_prev">
      <img src="../static/img/back_prev.png" alt>
    </div>
    <div class="content_detail">
      <div class="normal_content">
        <div class="title" v-if="contentDetail.bt">
          <span>{{contentDetail.bt}}</span>
        </div>
        <div class="sub_info_first">
          <div class="introduction" v-if="contentDetail.fbsj">
            <img src="../static/img/fbsj.png">
            <span>发布时间：{{contentDetail.fbsj}}</span>
          </div>
          <div class="introduction">
            <img src="../static/img/fgmt.png">
            <span>发稿来源：{{contentDetail.fgly?contentDetail.fgly:""}}</span>
          </div>
          <div class="introduction" v-if="contentDetail.lyqd">
            <img src="../static/img/lylx.png">
            <span>来源类型：{{contentDetail.lyqd}}</span>
          </div>
        </div>
        <div class="sub_info_last">
          <div class="introduction">
            <img src="../static/img/url.png">
            <span>
              原文链接：
              <a
                :href="contentDetail.ywlj"
                :title="contentDetail.ywlj"
                target="_blank"
              >{{contentDetail.ywlj}}</a>
            </span>
          </div>
          <div class="introduction">
            <img src="../static/img/reporter.png">
            <span>
              记者：
              <span
                v-for="(item, index) in contentDetail.jz"
                :key="item.xm"
              >
                <span v-if="index < 3 && item.xm">{{item.xm}}</span>
                <span v-if="index < contentDetail.jz.length-1">，</span>
              </span>
              <span v-if="contentDetail.jz && contentDetail.jz.length > 3">等</span>
            </span>
          </div>
          <div class="introduction">
            <img src="../static/img/editor.png">
            <span>
              责任编辑：
              <span
                v-for="(item, index) in contentDetail.zrbj"
                :key="item.xm"
              >
                <span v-if="index < 3 && item.xm">{{item.xm}}</span>
                <span v-if="index < contentDetail.zrbj.length-1">，</span>
              </span>
              <span v-if="contentDetail.zrbj && contentDetail.zrbj.length > 3">等</span>
            </span>
          </div>
        </div>
        <div class="box">
          <div class="box_first">
            <div>
              <span class="type">文本类型：</span>
              <span class="type_text">{{contentDetail.lx}}</span>
            </div>
            <div class="box_first_right">
              <span class="type">情感分析：</span>
              <img src="../static/img/happy.png">
              <span class="type_text">正能量{{znl}}</span>
              <img src="../static/img/mood.png" class="emotion_img">
              <span class="type_text">负能量{{fnl}}</span>
            </div>
          </div>
          <div style="margin-top:20px">
            <span class="type">关键词：</span>
            <span class="type_text">{{contentDetail.gjz}}</span>
          </div>
          <div style="margin-top:20px">
            <span class="type">摘要：</span>
            <span class="type_text">{{contentDetail.zhaiyao}}</span>
          </div>
        </div>
        <div class="text_box">
          <div class="text" v-html="contentDetail.zw"></div>
          <div v-for="(item, index) in imageList" :key="index" v-show="showImage">
            <img :src="item">
          </div>
          <!-- <iframe align="absmiddle" width="858px" height="610px"  :src="videoUrl" v-if="videoUrl">
                <meta name="referrer" content="no-referrer" />
          </iframe>-->
          <div id="video" style="width:858px;height:560px;" v-show="showCkPlayBox"></div>
          <div class="video_detail" v-show="showPlayBox">
            <div class="video_info">
              <div class="video_player">
                <div
                  id="jp_container_1"
                  class="jp-video jp-video-360p"
                  role="application"
                  aria-label="media player"
                  style="width:833px;border:1px solid #4187e5;"
                >
                  <div class="jp-type-single">
                    <div id="jquery_jplayer_1" class="jp-jplayer"></div>
                    <div class="jp-gui">
                      <div class="jp-video-play">
                        <button class="jp-video-play-icon" role="button" tabindex="0">play</button>
                      </div>
                      <div class="jp-interface">
                        <div class="jp-progress">
                          <div class="jp-seek-bar">
                            <div class="jp-play-bar"></div>
                          </div>
                        </div>
                        <div class="jp-current-time" role="timer" aria-label="time">&nbsp;</div>
                        <div class="jp-duration" role="timer" aria-label="duration">&nbsp;</div>
                        <div class="jp-controls-holder">
                          <div class="jp-controls">
                            <button class="jp-play" role="button" tabindex="0">play</button>
                            <button class="jp-stop" role="button" tabindex="0">stop</button>
                          </div>
                          <div class="jp-volume-controls">
                            <button class="jp-mute" role="button" tabindex="0">mute</button>
                            <button class="jp-volume-max" role="button" tabindex="0">max volume</button>
                            <div class="jp-volume-bar">
                              <div class="jp-volume-bar-value"></div>
                            </div>
                          </div>
                          <div class="jp-toggles">
                            <button class="jp-repeat" role="button" tabindex="0">repeat</button>
                            <button class="jp-full-screen" role="button" tabindex="0">full screen</button>
                          </div>
                        </div>
                        <!--  <div class="jp-details">
                                    <div class="jp-title" aria-label="title">&nbsp;</div>
                        </div>-->
                      </div>
                    </div>
                    <div class="jp-no-solution">
                      <span>Update Required</span>
                      To play the media you will need to either update your browser to a recent version or update your
                      <a
                        href="http://get.adobe.com/flashplayer/"
                        target="_blank"
                      >Flash plugin</a>.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ralation_chart">
          <div class="relation_diagram" id="relation_diagram"></div>
        </div>
      </div>
      <div class="content_right">
        <div class="attach_info">
          <div class="attach_text">
            <span>媒体单位</span>
          </div>
          <div class="attach_content">
            <div class="attach_item">
              <div class="attach_desc">
                <span class="attach_desc_text" v-if="media">{{media.mc}}</span>
              </div>
              <div class="attach_link">
                <div class="link_img">
                  <img src="../static/img/link.png" alt>
                </div>
                <span class="link_address">
                  <a
                    target="_blank"
                    :href="media.sydz"
                    :title="media.sydz"
                    v-if="media"
                  >{{media.sydz}}</a>
                </span>
              </div>
              <div class="attach_link">
                <div class="link_img">
                  <img src="../static/img/link_address.png" alt>
                </div>
                <span class="address" v-if="media">{{media.ssdy}}</span>
              </div>
            </div>
          </div>
          <no-data v-if="!media"/>
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>关联编辑</span>
          </div>
          <div class="attach_content">
            <div
              class="attach_link_info"
              @click="toEditor(item)"
              v-for="item in contentDetail.zrbj"
              :key="item.xm"
            >
              <div class="info_img">
                <img src="../static/img/avatar_big.png">
              </div>
              <div class="info_content">
                <span class="info_content_name">{{item.xm}}</span>
                <br>
                <span class="info_content_role">{{contentDetail.fgly}}-编辑</span>
              </div>
            </div>
          </div>
          <no-data v-if="!contentDetail.zrbj || contentDetail.zrbj.length == 0" />
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>关联记者</span>
          </div>
          <div class="attach_content">
            <div
              class="attach_link_info"
              @click="toReporter(item)"
              v-for="item in contentDetail.jz"
              :key="item.xm"
            >
              <div class="info_img">
                <img src="../static/img/avatar_big.png">
              </div>
              <div class="info_content">
                <span class="info_content_name">{{item.xm}}</span>
                <br>
                <span class="info_content_role">{{contentDetail.fgly}}-记者</span>
              </div>
            </div>
          </div>
          <no-data v-if="!contentDetail.jz || contentDetail.jz.length == 0"/>
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>内容人名</span>
          </div>
          <div
            class="attach_content_small"
            v-for="(item,index) in contentDetail.nrr"
            :key="index"
          >
            <div class="attach_link_info_small" @click="toPerson(item.xm)">
              <img src="../static/img/avatar_small.png">
              <span class="info_content_small_name">{{item.xm}}</span>
            </div>
          </div>
          <no-data v-if="(contentDetail.nrr && !contentDetail.nrr.length) || noPerson"/>
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>内容地点</span>
          </div>
          <div
            class="attach_content_small"
            v-for="(item,index) in contentDetail.nrdd"
            :key="index"
          >
            <div class="attach_link_info_small" @click="toAddress(item.mc)">
              <img src="../static/img/address.png">
              <span class="info_content_small_name">{{item.mc}}</span>
            </div>
          </div>
          <no-data v-if="(contentDetail.nrdd && !contentDetail.nrdd.length) || noSites"/>
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>内容机构</span>
          </div>
          <div class="attach_content">
            <div
              class="attach_link_info"
              v-for="(item,index) in contentDetail.nrjg"
              :key="index"
              @click="toOrganization(item.mc)"
            >
              <img src="../static/img/apartment.png">
              <span class="info_content_apartment_name">{{item.mc}}</span>
            </div>
          </div>
          <no-data v-if="(contentDetail.nrjg && !contentDetail.nrjg.length) || noJigou"/>
        </div>
        <div class="attach_info">
          <div class="attach_text">
            <span>相关推荐</span>
          </div>
          <div class="attach_content">
            <no-data v-if="true"/>
            <ul class="result_item" v-if="false">
              <li>
                <div class="item_title">
                  <span></span>
                </div>
                <br>
                <div class="item_detail">
                  <span>
                    <img src="../static/img/fbsj.png">发布时间：2018-10-10
                  </span>
                  <span>
                    <img src="../static/img/fgmt.png">多彩贵州网
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="totop_icon" @click.stop="backTop" v-if="topShow">
      <img src="../static/img/backTop.png" alt>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import headerSearch from "./headerSearch";
import { _get } from "../api/index.js";
import { playVideo } from "../helpers/jPlayer";
import { ckPlayVideo } from "../helpers/ckplayer.js";
import noData from './noData.vue'
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  components: {
    headerSearch,
    noData
  },
  data() {
    return {
      contentDetail: [],
      relation: [],
      media: [],
      showPlayBox: false,
      showCkPlayBox: false,
      videoUrl: "",
      imageList: [],
      showImage: false,
      topShow: false
    };
  },
  computed: {
    znl() {
      if (this.contentDetail.qgfx) {
        return (this.contentDetail.qgfx.znl * 100).toFixed(0) + "%";
      }
    },
    fnl() {
      if (this.contentDetail.qgfx) {
        return (this.contentDetail.qgfx.fnl * 100).toFixed(0) + "%";
      }
    },
    noPerson() {
      if (typeof this.contentDetail.nrr == "undefined") {
        return true;
      }
      return false;
    },
    noJigou() {
      if (typeof this.contentDetail.nrjg == "undefined") {
        return true;
      }
      return false;
    },
    noSites() {
      if (typeof this.contentDetail.nrdd == "undefined") {
        return true;
      }
      return false;
    }
  },
  beforeDestroy() {
    document
      .getElementById("app")
      .removeEventListener("scroll", this.handleBack);
    document
      .getElementById("app")
      .removeEventListener("scroll", this.handleTop);
  },
  mounted() {
    //this.draw_diagram()
    document.getElementById("app").addEventListener("scroll", this.handleTop);
    document.getElementById("app").addEventListener("scroll", this.handleBack);
    this.$nextTick(() => {
      this.getContentDetail();
      if (this.$route.query.url) {
        this.videoUrl = this.$route.query.url;
        //this.showPlayBox = true
        //console.log(this.$route.query.url[0])
        playVideo(this.$route.query.url[0]);
      }
    });
  },
  destroyed() {
    $("#jquery_jplayer_1").jPlayer("destroy");
  },
  methods: {
    handleTop() {
      if (document.getElementById("app").scrollTop > 600) {
        this.topShow = true;
      } else {
        this.topShow = false;
      }
      //console.log(document.getElementById('app').scrollTop)
    },
    backTop() {
      var body = document.getElementById("app");
      var speed = (body.scrollTop / 100) * 10;
      var timer = setInterval(() => {
        body.scrollTop = body.scrollTop - speed;
        if (body.scrollTop == 0 && body.scrollTop < speed) {
          clearInterval(timer);
        }
      }, 20);
      //console.log(document.getElementById('app').scrollTop)
    },
    getContentDetail() {
      //debugger
      if (this.$route.path === "/contentsearch/contentDetail") {
        let id = this.$route.query.id;
        let url = "contents/" + id;
        _get(url)
          .then(res => {
            //console.log(res)
            if (res.data.data.data) {
              this.contentDetail = res.data.data.data;
              //console.log(this.contentDetail)
            }
            if (res.data.data.relation) {
              this.relation = res.data.data.relation;
            }
            this.media = res.data.data.media;
            if (this.relation) {
              this.draw_diagram();
            }
            if (
              this.contentDetail.urls &&
              this.contentDetail.lx.indexOf("视频") > -1
            ) {
              var url = this.contentDetail.urls[0];
              if (url.indexOf(".m3u8") > -1) {
                this.showCkPlayBox = true;
                ckPlayVideo(url);
              } else {
                this.showPlayBox = true;
                //console.log(this.$route.query.url[0])
                playVideo(url);
              }
            }
            if (
              this.contentDetail.urls &&
              this.contentDetail.lx.indexOf("图片") > -1
            ) {
              this.showImage = true;
              this.imageList = this.contentDetail.urls;
            }
          })
          .catch(res => {
            console.log(res);
          });
      }
      if (this.$route.path === "/content_things/contentdetail") {
        let id = this.$route.query.id;
        let url = "content-things/" + id;
        let type = this.$route.query.type;
        let index = this.$route.query.index;
        _get(url, { id: id, type: type, index: index })
          .then(res => {
            this.contentDetail = res.data.data.data;
            //console.log(this.contentDetail)
            if (res.data.data.relation) {
              this.relation = res.data.data.relation;
            }
            this.media = res.data.data.media;
            if (this.relation) {
              this.draw_diagram_content();
            }
            if (
              this.contentDetail.urls &&
              this.contentDetail.lx.indexOf("视频") > -1
            ) {
              var url = this.contentDetail.urls[0];
              if (url.indexOf(".m3u8") > -1) {
                this.showCkPlayBox = true;
                ckPlayVideo(url);
              } else {
                this.showPlayBox = true;
                //console.log(this.$route.query.url[0])
                playVideo(url);
              }
            }
            if (
              this.contentDetail.urls &&
              this.contentDetail.lx.indexOf("图片") > -1
            ) {
              this.showImage = true;
              this.imageList = this.contentDetail.urls;
            }
          })
          .catch(res => {
            console.log(res);
          });
      }
    },
    handleBack() {
      if (document.getElementById("app").scrollTop > 100) {
        this.$refs.back_prev.style.top = "2%";
      } else {
        this.$refs.back_prev.style.top = "9%";
      }
    },
    toPerson(name) {
      this.$router.push({
        path: "/contentName",
        query: { type: "person", index: name, sort: "desc", from: 0, size: 10 }
      });
    },
    toAddress(name) {
      this.$router.push({
        path: "/contentSites",
        query: { type: "address", index: name, sort: "desc", from: 0, size: 10 }
      });
    },
    toOrganization(name) {
      this.$router.push({
        path: "/contentDepartment",
        query: {
          type: "organization",
          index: name,
          sort: "desc",
          from: 0,
          size: 10
        }
      });
    },
    toContent(name) {
      this.$router.push({
        path: "/contentsearch",
        query: { index: name, sort: "desc", from: 0, size: 10 }
      });
    },
    toEditor(item) {
      this.$router.push({
        //你需要接受路由的参数再跳转
        path: "/reporters/reportersdetail",
        query: { id: item.id, zw: "编辑" }
      });
    },
    toReporter(item) {
      this.$router.push({
        //你需要接受路由的参数再跳转
        path: "/reporters/reportersdetail",
        query: { id: item.id, zw: "记者" }
      });
    },
    backPrev() {
      window.history.go(-1);
      setTimeout(() => {
        this.$router.go(0);
      }, 20);
    },
    draw_diagram() {
      var self = this;
      var size = 60;
      var size1 = 50;
      var arr = this.relation[0];
      var arr1 = [];
      var arr2 = [];
      var arr3 = [];
      var arrTitle = [
        {
          ID: arr.id,
          name: "title",
          source: "title",
          symbolSize: 70,
          showName: arr.name,
          category: 0
        }
      ];
      if (arr && arr.nrjg) {
        for (var i = 0; i < arr.nrjg.length; i++) {
          arr1.push({
            ID: arr.nrjg[i].id,
            name: "nrjg" + i,
            showName: arr.nrjg[i].mc,
            source: "nrjg" + i,
            symbolSize: size,
            category: 1
          });
          for (var j = 0; j < arr.nrjg[i].jz.length; j++) {
            arr1.push({
              ID: arr.nrjg[i].jz[j].rid,
              name: "nrjgjz" + i + j,
              showName: arr.nrjg[i].jz[j].name,
              source: "nrjg" + i,
              symbolSize: size1,
              category: 4
            });
          }
        }
      }
      if (arr && arr.nrdd) {
        for (var i = 0; i < arr.nrdd.length; i++) {
          arr2.push({
            ID: arr.nrdd[i].id,
            name: "nrdd" + i,
            showName: arr.nrdd[i].mc,
            source: "nrdd" + i,
            symbolSize: size,
            category: 2
          });
          for (var j = 0; j < arr.nrdd[i].jz.length; j++) {
            arr2.push({
              ID: arr.nrdd[i].jz[j].rid,
              name: "nrddjz" + i + j,
              showName: arr.nrdd[i].jz[j].name,
              source: "nrdd" + i,
              symbolSize: size1,
              category: 4
            });
          }
        }
      }
      if (arr && arr.nrr) {
        for (var i = 0; i < arr.nrr.length; i++) {
          arr2.push({
            ID: arr.nrr[i].id,
            name: "nrr" + i,
            showName: arr.nrr[i].xm,
            source: "nrr" + i,
            symbolSize: size,
            category: 3
          });
          for (var j = 0; j < arr.nrr[i].jz.length; j++) {
            arr3.push({
              ID: arr.nrr[i].jz[j].rid,
              name: "nrrjz" + i + j,
              showName: arr.nrr[i].jz[j].name,
              source: "nrr" + i,
              symbolSize: size1,
              category: 4
            });
          }
        }
      }

      arr1 = arrTitle
        .concat(arr1)
        .concat(arr2)
        .concat(arr3);
      var links1 = [];
      var linksTitle = [];
      for (var i = 0; i < arr1.length; i++) {
        links1.push({
          source: arr1[i].source,
          target: arr1[i].name
        });
      }
      if (arr && arr.nrjg) {
        for (var i = 0; i < arr.nrjg.length; i++) {
          linksTitle.push({
            source: "title",
            target: "nrjg" + i
          });
        }
      }
      if (arr && arr.nrdd) {
        for (var i = 0; i < arr.nrdd.length; i++) {
          linksTitle.push({
            source: "title",
            target: "nrdd" + i
          });
        }
      }
      if (arr && arr.nrr) {
        for (var i = 0; i < arr.nrr.length; i++) {
          linksTitle.push({
            source: "title",
            target: "nrr" + i
          });
        }
      }

      links1 = links1.concat(linksTitle);
      var myChart = echarts.init(document.getElementById("relation_diagram"));

      myChart.setOption({
        tooltip: {
          formatter: function(params) {
            return params.data.showName;
          }
        },
        color: ["#E6A23C", "#409EFF", "#67C23A", "#F56C6C", "#6CE7F5"],
        legend: [
          {
            data: ["当前文章", "内容机构", "内容地点", "内容人", "编辑记者"],
            icon: "circle",
            itemWidth: 15,
            itemGap: 35
          }
        ],
        series: [
          {
            name: "关系图",
            type: "graph",
            layout: "force",
            force: {
              repulsion: 500,
              gravity: 0.1,
              edgeLength: 10,
              layoutAnimation: false
            },
            data: arr1,
            links: links1,
            categories: [
              { name: "当前文章" },
              { name: "内容机构" },
              { name: "内容地点" },
              { name: "内容人" },
              { name: "编辑记者" }
            ],
            roam: true,
            focusNodeAdjacency: true,
            label: {
              normal: {
                show: true,
                position: "inside",
                fontSize: 12,
                color: "#fff",
                fontFamily: "思源黑体-Bold",
                formatter: function(params) {
                  var text = params.data.showName;
                  if (text.length <= 5) {
                    return text;
                  } else if (text.length <= 9) {
                    return `${text.slice(0, 4)}\n${text.slice(4)}`;
                  } else {
                    return `${text.slice(0, 4)}\n${text.slice(
                      4,
                      9
                    )}\n${text.slice(9, 12)}…`;
                  }
                }
              }
            },
            lineStyle: {
              normal: {
                show: true,
                width: 2,
                color: "target",
                curveness: 0.3,
                type: "solid"
              }
            }
          }
        ]
      });
      myChart.on("click", function(param) {
        var type = param.data.category;
        var id = param.data.ID;
        var index = param.data.showName;
        switch (type) {
          case 1:
            self.$router.push({
              path: "/contentDepartment",
              query: {
                type: "organization",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
          case 2:
            self.$router.push({
              path: "/contentSites",
              query: {
                type: "address",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
          case 3:
            self.$router.push({
              path: "/contentName",
              query: {
                type: "person",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
          case 4:
            self.$router.push({
              path: "/reporters/reportersdetail",
              query: { id: id }
            });
            break;
        }
      });
    },
    draw_diagram_content() {
      var contentName = "";
      if (this.$route.query.type == "address") {
        contentName = "内容地点";
      } else if (this.$route.query.type == "person") {
        contentName = "内容人";
      } else {
        contentName = "内容机构";
      }
      var self = this;
      var size = 80;
      var size1 = 60;
      var arr = this.relation;
      //console.log(arr)
      var arr1 = [];
      var arrTitle = [];
      for (var i = 0; i < arr.length; i++) {
        arrTitle.push({
          ID: arr[i].id,
          name: "title" + i,
          showName: arr[i].name,
          source: "title" + i,
          symbolSize: 100,
          category: 0
        });
      }
      if (arr[0].mt) {
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < arr[i].mt.length; j++) {
            arr1.push({
              ID: arr[i].mt[j].mid,
              name: "mt" + i + j,
              showName: arr[i].mt[j].name,
              source: "title" + i,
              symbolSize: size,
              category: 1
            });
          }
        }
      }
      if (arr[0].wz) {
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < arr[i].wz.length; j++) {
            arr1.push({
              ID: arr[i].wz[j].id,
              name: "wz" + i + j,
              showName: arr[i].wz[j].bt,
              source: "title" + i,
              symbolSize: size,
              category: 2
            });
          }
        }
      }
      arr1 = arrTitle.concat(arr1);
      var links1 = [];
      for (var i = 0; i < arr1.length; i++) {
        links1.push({
          source: arr1[i].source,
          target: arr1[i].name
        });
      }
      // console.log(arr1)
      // console.log(links1)
      var myChart = echarts.init(document.getElementById("relation_diagram"));

      myChart.setOption({
        tooltip: {
          formatter: function(params) {
            return params.data.showName;
          }
        },
        color: ["#E6A23C", "#409EFF", "#67C23A", "#F56C6C", "#6CE7F5"],
        legend: [
          {
            data: [contentName, "媒体", "文章"],
            icon: "circle",
            itemWidth: 15,
            itemGap: 35
          }
        ],
        series: [
          {
            name: "关系图",
            type: "graph",
            layout: "force",
            force: {
              repulsion: 500,
              gravity: 0.1,
              edgeLength: 100,
              layoutAnimation: false
            },
            data: arr1,
            links: links1,
            categories: [
              { name: contentName },
              { name: "媒体" },
              { name: "文章" }
            ],
            roam: true,
            focusNodeAdjacency: true,
            label: {
              normal: {
                show: true,
                position: "inside",
                fontSize: 14,
                color: "#fff",
                fontFamily: "思源黑体-Bold",
                formatter: function(params) {
                  var text = params.data.showName;
                  if (text.length <= 5) {
                    return text;
                  } else if (text.length <= 9) {
                    return `${text.slice(0, 4)}\n${text.slice(4)}`;
                  } else {
                    return `${text.slice(0, 4)}\n${text.slice(
                      4,
                      9
                    )}\n${text.slice(9, 12)}…`;
                  }
                }
              }
            },
            lineStyle: {
              normal: {
                show: true,
                width: 2,
                color: "target",
                curveness: 0.3,
                type: "solid"
              }
            }
          }
        ]
      });
      myChart.on("click", function(param) {
        var type = param.data.category;
        if (param.data.category == 0) {
          if (self.$route.query.type == "person") {
            type = 3;
          } else if (self.$route.query.type == "address") {
            type = 4;
          } else {
            type = 5;
          }
        }
        var id = param.data.ID;
        var index = param.data.showName;
        switch (type) {
          case 1:
            self.$router.push({
              //你需要接受路由的参数再跳转
              path: "/pressMedia/pressmediadetail",
              query: { id: id }
            });
            location.reload();
            break;
          case 2:
            self.$router.push({
              //你需要接受路由的参数再跳转
              path: "/contentsearch/contentDetail",
              query: { id: id }
            });
            location.reload();
            break;
          case 3:
            self.$router.push({
              path: "/contentName",
              query: {
                type: "person",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
          case 4:
            self.$router.push({
              path: "/contentSites",
              query: {
                type: "address",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
          case 5:
            self.$router.push({
              path: "/contentDepartment",
              query: {
                type: "organization",
                index: index,
                sort: "desc",
                from: 0,
                size: 10
              }
            });
            location.reload();
            break;
        }
      });
    },
    searchNewWord(newWords, value) {
      //console.log(newWords)
      ///console.log(value)
      switch (value) {
        case "1":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentsearch",
            query: { index: newWords, sort: "desc", from: 0, size: 10 }
          });
          location.reload();
          break;
        case "2":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/pressMedia",
            query: { index: newWords, from: 0, size: 10 }
          });
          location.reload();
          break;
        case "3":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/editorReporter",
            query: { index: newWords, from: 0, size: 10 }
          });
          location.reload();
          break;
        case "4":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentName",
            query: {
              index: newWords,
              type: "person",
              sort: "desc",
              from: 0,
              size: 10
            }
          });
          location.reload();
          break;
        case "5":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentDepartment",
            query: {
              index: newWords,
              type: "address",
              sort: "desc",
              from: 0,
              size: 10
            }
          });
          location.reload();
          break;
        case "6":
          this.$router.push({
            //你需要接受路由的参数再跳转
            path: "/contentSites",
            query: {
              index: newWords,
              type: "organization",
              sort: "desc",
              from: 0,
              size: 10
            }
          });
          location.reload();
          break;
      }
      if (this.handleValue === value) {
        location.reload();
      }
    }
  }
};
</script>

<style scoped>
.content_detail {
  width: 1200px;
  margin: 20px auto;
  display: flex;
}
.normal_content {
  width: 904px;
  background: rgba(255, 255, 255, 1);
  float: left;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px 0px 0px 6px;
}
.title {
  width: 864px;
  height: 18px;
  font-size: 18px;
  padding: 30px 20px 5px;
  font-family: 思源黑体;
  font-weight: 550;
  color: rgba(51, 51, 51, 1);
  line-height: 16px;
  letter-spacing: 2px;
}
.sub_info_first {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.sub_info_last {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.introduction {
  width: 280px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 20px 5px;
  box-sizing: border-box;
}
.introduction img {
  width: 12px;
  height: 12px;
}
.introduction span {
  width: 240px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  box-sizing: border-box;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.introduction > span {
  margin-left: 8px;
}
.introduction span span {
  margin-left: -3px;
}
.introduction span a {
  text-decoration: none;
  color: rgba(153, 153, 153, 1);
}
.box {
  width: 830px;
  padding: 15px;
  margin: 20px auto;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  background: rgba(248, 248, 248, 1);
}
.box .type {
  height: 12px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.box .type_text {
  height: 12px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 0.7);
  letter-spacing: 2px;
}
.box_first {
  display: flex;
  justify-content: space-between;
}
.box_first_right {
  margin-right: 10%;
}
.box_first_right img {
  width: 12px;
  height: 12px;
}
.emotion_img {
  margin-left: 20px;
}
.text_box {
  width: 95%;
  padding: 15px;
  margin: 20px auto;
  border-bottom: 1px solid rgba(204, 204, 204, 1);
}
.text_box .text {
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 25px;
  letter-spacing: 3px;
  word-break: break-all;
  white-space: normal;
}
.relation_chart {
  border-bottom: 1px solid rgba(204, 204, 204, 1);
}
.relation_diagram {
  width: 92%;
  height: 800px;
  margin: 10px auto;
}
.left_box {
  float: right;
  box-sizing: border-box;
}
.associate_editor {
  width: 280px;
  height: 120px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px 0px 0px 0px;
}
.associate_editor_title {
  width: 280px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px 6px 0px 0px;
}
.attach_info {
  width: 280px;
  margin-bottom: 20px;
  float: right;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 6px 0px 0px;
}
.attach_text {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 0 10px 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px 6px 0px 0px;
}
.attach_text span {
  font-size: 18px;
  color: #333333;
}
.attach_item {
  height: 120px;
  margin: 20px 10px;
}
.attach_desc {
  margin: 20px 10px;
  display: flex;
  justify-content: flex-start;
}
.attach_desc_text {
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 16px;
}
.attach_img img {
  height: 23px;
  margin-left: 20px;
}
.info_item {
  width: 275px;
  height: 82px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px dashed #ccc;
}
.attach_link {
  margin: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.link_img img {
  height: 24px;
  width: 24px;
}
.link_address {
  width: 200px;
  margin-left: 20px;
  font-size: 18px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  height: 40px;
  line-height: 34px;
  text-overflow: ellipsis;
}
.link_address a {
  color: rgba(102, 102, 102, 1);
  text-decoration: none;
}
.address {
  width: 200px;
  margin-left: 20px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.info_img {
  width: 40px;
  height: 40px;
}
.info_content {
  margin-left: 15px;
  line-height: 20px;
}
.info_content_name {
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 16px;
}
.info_content_role {
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
}
.attach_link_info {
  margin: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}
.attach_link_info:last-child {
  border-bottom: none;
}
.attach_content_small {
  margin: 20px;
  display: inline-table;
}
.attach_link_info_small {
  width: 90px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.info_content_small_name {
  margin-left: 10px;
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.info_content_apartment_name {
  width: 200px;
  margin-left: 10px;
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.result_item li {
  padding: 8px 0;
  margin: 15px;
  border-bottom: 1px dotted #eee;
  list-style-type: none;
}
.result_item li:last-child {
  border-bottom: none;
}
.item_title {
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item_detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item_detail img {
  margin-top: 13px;
  margin-right: 5px;
}
.item_detail span {
  font-size: 12px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  margin-right: 10px;
}
.el-icon-caret-right:before {
  content: "\E60E";
  display: none;
}
.back_prev {
  position: fixed;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6;
  font-size: 14px;
  top: 9%;
  left: 2%;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  background-color: #00c2ff;
}
.back_prev:hover {
  background-color: #3d76ff;
}
.back_prev img {
  height: 20px;
  width: 20px;
}
.totop_icon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  background-color: #ccc;
  border-radius: 3px;
  position: fixed;
  bottom: 9%;
  right: 12%;
  cursor: pointer;
}
.totop_icon:hover {
  background-color: #999999;
}
.totop_icon img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/contentDetail.vue